module.exports = __webpack_public_path__ + "static/assets/6ef068dacd4d0cf39dc6849079065217.png";